<template>
    <div>
        <van-nav-bar  title="种植选址"  left-text="返回"  @click-left="back"    left-arrow>
            
        </van-nav-bar>
        <div class='main'>
            <div id="gdMap"></div>
            <van-divider :style="{ color: '#0076bf', borderColor: '#0076bf', padding: '0 16px' }">雷达图</van-divider>
            <div class='antV_charts' style="width:100%">
       			<canvas id="charts_radar" style="width:100%;height:200px"></canvas>
     		</div>
        </div>
        
        
    </div>
</template>

<script>
import AMap from 'AMap'
// import AMapUI from 'AMapUI'
const F2 = require('@antv/f2/lib/index')
import {getradarChart} from '@/request/data'
import {mapState} from 'vuex'
export default {
    name:'plantingSite',
    data() {
        return {
            radarData:[]
        }
    },
    computed: {
        ...mapState(['phonePosition'])
    },
    created(){
           
    },
    mounted() {
        this.createMap()
    },
    methods: {
        createMap(){
            let map = new AMap.Map('gdMap', {
                resizeEnable: true,
                center: [this.phonePosition.lon,this.phonePosition.lat],
                zoom: 15
            });

            let marker = new AMap.Marker({
                position: map.getCenter(),
                // icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                // offset: new AMap.Pixel(-13, -30)
            });
            marker.setMap(map);
            // //  label默认蓝框白底左上角显示，样式className为：amap-marker-label
            // marker.setLabel({
            //     offset: new AMap.Pixel(0,0),  //设置文本标注偏移量
            //     content: "<div class='info'>" + this.phonePosition.address + "</div>", //设置文本标注内容
            //     direction: 'right' //设置文本标注方位
            // });

            
            this.radarChart()
        },
        radarChart(){
            let data ={}
            data.lat = this.phonePosition.lat
            data.lon = this.phonePosition.lon
            getradarChart(data).then(res=>{
                if (res.data.code == 0 ) {    
                    this.radarData = []
                    let keyArr = Object.keys(res.data.data) 
                    for (let i = 0; i < keyArr.length; i++) {                       
                        let data ={}
                        switch (keyArr[i]) {
                            case 'pre_sum':
                                data.item = '累计雨量( '+res.data.data[keyArr[i]]+ ' mm)' 
                                break;
                            case 'tmp_avg':
                                data.item = '平均温度( '+res.data.data[keyArr[i]]+' ℃)'
                                break;
                            case 'win_avg':
                                data.item = '平均风速( '+res.data.data[keyArr[i]]+' m/s)'
                                break;
                            case 'rhf_avg':
                                data.item = '空气相对湿度( '+res.data.data[keyArr[i]]+' %)'
                                break;
                            case 'ssra_avg':
                                data.item = '短波辐射( '+res.data.data[keyArr[i]]+' W/m2)'
                                break;                        
                            default:
                                break;
                        }
                        // data.item = keyArr[i]
                        data.data = res.data.data[keyArr[i]]
                        this.radarData.push(data)    
                    }
                    this.addRadar()
                }
            })
        },
        addRadar(){
            var chart = new F2.Chart({
                id: 'charts_radar',
                pixelRatio: window.devicePixelRatio
            });

            chart.coord('polar');
            chart.source(this.radarData, {
                score: {
                min: 0,
                max: 500,
                nice: false,
                tickCount: 5
                }
            });

            chart.axis('data', {
                label: function label(text, index, total) {                    
                if (index === total - 1) {
                    return null;
                }
                return {
                    top: true
                };
                },
                grid: {
                lineDash: null,
                type: 'arc' // 弧线网格
                }
            });
            chart.axis('item', {
                grid: {
                lineDash: null
                }
            });
            chart.line().position('item*data').color('#0076bf');
            chart.point().position('item*data').color('#0076bf').style({
                stroke: '#fff',
                lineWidth: 1
            });
            chart.render();
        },
        back(){
            this.$router.back(-1)
        }
    },
}
</script>
<style scoped>
.main{ position:relative; width:100%; top:46px; bottom:0;overflow:auto;}
#gdMap{width:100%;height:250px}



</style>